export default __webpack_public_path__ + "static/media/bit1.36057659.svg";